if ( ! Object.extend ) {
	Object.extend = function(destination, source) {
	    return $.extend(true, destination, source) ;
      // for (var property in source) {
	    //     if (source.hasOwnProperty(property)) {
	    //         destination[property] = source[property];
	    //     }
	    // }
	    // return destination;
	};
}

if ( ! Object.values ) {
  Object.values = function(object) {
    var values = [];
    for(var property in object) {
      if ( object.hasOwnProperty(property))
        values.push(object[property]);
    }
    return values;
  }
}


if ( ! Number.isNumeric ) {
	Number.isNumeric = function(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
}

function isFunction(functionToCheck) {
	var getType = {};
	return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
